import { http } from '../http';

export const selectAuthOption = async (contactId, authOptionId) => {
  try {
    const url = '/auth/select-options';
    await http.get(url, {
      params: {
        contactId,
        authOptionId,
      },
      baseURL: process.env.BFFV2_BASE_URL,
    });
  } catch (e) {
    console.error('something went wrong', e);
    throw e;
  }
};

export default {
  selectAuthOption,
};
